import React, { useContext, useEffect, useState, useCallback } from "react";
// @ts-ignore
import UserContext from "../../utils/UserContext";
import Courses from "../../components/SatCourse/Courses";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import UrlNames from "../../constants/UrlNames";
// @ts-ignore
import { NavigateToLanding } from "../../utils/CommonFunction";

export interface CoursesScreenProps {
  token?: string;
  loaderStatus?: (status: boolean) => void;
}

const CoursesScreen: React.FC<CoursesScreenProps> = (props) => {
  const {
    satCourseData,
    setCheckSatNavbar,
    setCheckRefresh,
    setActiveIndex,
    subscriberId,
  } = useContext<any>(UserContext);
  
  const [isError, setError] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    if (subscriberId) {
      setCheckRefresh(true);
    } else {
      NavigateToLanding();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriberId, setCheckRefresh]);

  const HandleId = useCallback((id: string | number, index: number) => {
    setActiveIndex(index);
    navigate(UrlNames.chapters, {
      state: {
        id: id,
        index: index,
      },
    });
  }, [navigate, setActiveIndex]);

  const HandleBookMarkScreen = useCallback(() => {
    navigate(UrlNames.bookMark, {
      state: {
        title: "Bookmark",
        index: 3,
      },
    });
  }, [navigate]);

  const HandleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const HandleHidden = useCallback(() => {
    setCheckSatNavbar(false);
  }, [setCheckSatNavbar]);

  return (
    <>
      <Courses
        isError={isError}
        HandleId={HandleId}
        satCourseData={satCourseData}
        HandleBookMarkScreen={HandleBookMarkScreen}
        HandleGoBack={HandleGoBack}
        HandleHidden={HandleHidden}
      />
    </>
  );
};
export default CoursesScreen;
